<div *ngIf="block && block.length" class="d-flex flex-row justify-content-start container-card-date no-print">
    <ng-container *ngFor="let item of block; let idx = index;">
        <div class="card p-4 text-left d-flex flex-column justify-content-between align-items-stretch" [ngClass]="{
                'mx-2': idx !== 0 && idx !== block.length - 1,
                'me-2': idx === 0,
                'ms-2': idx === block.length - 1
            }">
            <div>
                <div class="w-50 border-grey__bottom">
                    <p *ngIf="item.indicazione_temporale" class="ls-label-large mb-2" [class.text-support-40]="item.colore === 'Oro'"
                        [class.text-brand-40]="item.colore === 'Verde'">
                        {{ item.indicazione_temporale }}
                    </p>
                    <p class="ls-label-xl-large text-garamond text-uppercase mb-1"
                        [class.text-support-40]="item.colore === 'Oro'" [class.text-brand-40]="item.colore === 'Verde'">
                        {{ item.data | date: 'dd' }}</p>
                    <p class="ls-label-xl-large text-garamond text-uppercase mb-1"
                        [class.text-support-40]="item.colore === 'Oro'" [class.text-brand-40]="item.colore === 'Verde'">
                        {{ item.data | localizedDate: 'MMM' }}</p>
                    <p class="ls-label-xl-large text-garamond text-uppercase mb-3"
                        [class.text-support-40]="item.colore === 'Oro'" [class.text-brand-40]="item.colore === 'Verde'">
                        {{ item.data | date: 'yyyy' }}</p>
                    <p class="ls-label-large text-uppercase min-height-hours" [class.text-support-40]="item.colore === 'Oro'"
                        [class.text-brand-40]="item.colore === 'Verde'">
                        <span *ngIf="item.orario">{{ item.orario }}</span>
                    </p>
                </div>
                <div *ngIf="item.testo_formattato" class="text-custom px-0 mt-4" [innerHTML]="item.testo_formattato | safeHtml"></div>
            </div>
            <div *ngIf="item.link_cta">
                <a *ngIf="!nodeService.verifyLinkExternal(item.link_cta.url)" [routerLink]="navigationService.splitUrlRouterLink(item.link_cta.url).path" [queryParams]="navigationService.splitUrlRouterLink(item.link_cta.url).queryParams">
                    <button class="btn btn-transparent p-0">
                        <p [class.text-support-40]="item.colore === 'Oro'"
                            [class.text-brand-40]="item.colore === 'Verde'"
                            class="mb-0 text-uppercase fs-12 position-relative"
                            [class.line-news-hover-bottom-support]="item.colore === 'Oro'"
                            [class.line-news-hover-bottom-brand]="item.colore === 'Verde'" [innerHTML]="item.label_cta">
                        </p>
                    </button>
                </a>
                <a *ngIf="nodeService.verifyLinkExternal(item.link_cta.url)" [href]="item.link_cta.url">
                    <button class="btn btn-transparent p-0">
                        <p [class.text-support-40]="item.colore === 'Oro'"
                            [class.text-brand-40]="item.colore === 'Verde'"
                            class="mb-0 text-uppercase fs-12 position-relative"
                            [class.line-news-hover-bottom-support]="item.colore === 'Oro'"
                            [class.line-news-hover-bottom-brand]="item.colore === 'Verde'" [innerHTML]="item.label_cta">
                        </p>
                    </button>
                </a>
            </div>
        </div>
    </ng-container>
</div>
<ng-container *ngFor="let item of block; let idx = index;">
    <app-sample-print [date]="item.data" [description]="item.testo_formattato"></app-sample-print>
</ng-container>